// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3Jd6D","content":"Consent_content__1_MaQ","footer":"Consent_footer__cCxu_"};